<div class="flex flex-row justify-start items-center" *ngIf="(this.item.cells['TargetTopic']
      && this.item.cells['TargetTopic'].value != null
      && this.item.cells[this.fieldDefinition.key].value == null
      && this.item.cells['IsCustom'].value == true
    )">
  <button mat-button *ngIf="!item?.cells?.HideMapAsNewFieldButton" (click)="mapField(true)"
          class="light-orange-button m-r-10">Map as New Field
  </button>
  <button mat-button (click)="mapField(false)"
          class="light-orange-button">{{item?.cells?.MapAsExistingFieldButtonText ? item?.cells?.MapAsExistingFieldButtonText.value : 'Map to Existing Field'}}</button>
</div>

<div class="w-p-100 flex flex-row justify-start items-center"
     *ngIf="item.cells[fieldDefinition.key] && item.cells[fieldDefinition.key].displayText">
  <div class="ellipse" matTooltip="{{item.cells[fieldDefinition.key]?.displayText}} ">
    {{item.cells[fieldDefinition.key]?.displayText}}
  </div>
  <button mat-icon-button class="icon-dropdown-button"
          [ngClass]="{'link-button': item?.cells?.RenderAsLink?.value}"
          *ngIf="this.item.cells['IsCustom'].value === true" (click)="remove()">
          <mat-icon>edit</mat-icon>
  </button>
  <button mat-button class="link-button m-r-10 margin-left-auto"
          *ngIf="item?.cells?.Match?.value === true" (click)="showInfo()">
    (Match Field)
  </button>
</div>


